import { LoadableTasksWork } from "features";
import React from "react";
import { Breadcrumb } from "shared/ui/components";

export default function TasksWorkPage() {
  return (
    <>
      <Breadcrumb
        preCrumb={{ text: "myWork", link: "/documents" }}
        listPath={["/editableDocuments"]}
      />
      <LoadableTasksWork />
    </>
  );
}
